import type {
  DispatchCreatePayload,
  DispatchCreateResult,
  EmpresaListParams,
  EmpresaRow,
  FileListParams,
  SpedFile,
} from "@/types/autosped";

import { api, type Paged, unwrap, unwrapWithMeta } from "./axiosConfig";

const base = (wsId: number) => `/api/v1/workspaces/${wsId}/autosped`;

export const autospedService = {
  async listEmpresas(workspaceId: number, params?: EmpresaListParams): Promise<Paged<EmpresaRow[]>> {
    return unwrapWithMeta(api.get(`${base(workspaceId)}/empresas`, { params }));
  },

  async listFiles(
    workspaceId: number,
    clientId: number,
    params?: FileListParams,
  ): Promise<Paged<SpedFile[]>> {
    return unwrapWithMeta(
      api.get(`${base(workspaceId)}/empresas/${clientId}/arquivos`, { params }),
    );
  },

  async createDispatch(
    workspaceId: number,
    payload: DispatchCreatePayload,
  ): Promise<DispatchCreateResult> {
    return unwrap(api.post(`${base(workspaceId)}/dispatches`, payload));
  },

  async reexecutar(
    workspaceId: number,
    dispatchId: number,
    forcarRedownload = false,
  ): Promise<DispatchCreateResult> {
    return unwrap(
      api.put(`${base(workspaceId)}/dispatches/${dispatchId}/reexecutar`, {
        forcar_redownload: forcarRedownload,
      }),
    );
  },

  async downloadUrl(workspaceId: number, fileId: number): Promise<string> {
    const { url } = await unwrap<{ url: string }>(
      api.get(`${base(workspaceId)}/arquivos/${fileId}/download`),
    );
    return url;
  },

  async downloadZip(workspaceId: number, fileIds: number[]): Promise<Blob> {
    const resp = await api.post(
      `${base(workspaceId)}/arquivos/download-zip`,
      { file_ids: fileIds },
      { responseType: "blob" },
    );
    return resp.data as Blob;
  },
};
